module.exports = __webpack_public_path__ + "media/images/image3-9ce9ceec9102806e1784596573364a55.png";